import {
    GET_HISTORICAL_REQUEST,
    GET_HISTORICAL_SUCCESS,
    GET_HISTORICAL_FAILURE,
    SET_HISTORICAL
} from '../actions/historical';
import { buildHistories } from '../helpers/historical';

const initialState = {
    historical: [],
    fetching: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_HISTORICAL_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_HISTORICAL_SUCCESS: {
            return {
                ...state,
                fetching: false,
                historical: buildHistories(action.payload.historical, action.payload.statuses)
            };
        }
        case GET_HISTORICAL_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_HISTORICAL: {
            return {
                ...state,
                historical: action.payload.historical
            };
        }
        default:
            return state;
    }
};
